// Generated file : do not modify
export enum AttestationStatuts
{
  NONE = 0,
  NON_DEMANDE,
  DEMANDE,
  PRIS_EN_CHARGE,
  REFUSE,
  OBTENU
};

import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Attestation
export default class Attestation  {
  // Identifiant unique
  public id: number;
  // Etablissement
  public etablissementId: number;
  // Organisme
  public attestationDefId: number;
  // Date de la demande
  public dateDemande: Date | null;
  // Date de mise à jour
  public dateStatut: Date | null;
  // Date de validité
  public dateValid: Date | null;
  // Statut
  public statut: AttestationStatuts;
  // Motif de refus
  public motif: string;
  // Peut être renouvellé ou demandé
  public canRenew: boolean;
  // ID document
  public documentId: number;
  // Import du document fait
  public import: boolean;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.etablissementId = 0;
    this.attestationDefId = 0;
    this.dateDemande = null;
    this.dateStatut = null;
    this.dateValid = null;
    this.statut = AttestationStatuts.NONE;
    this.motif = '';
    this.canRenew = false;
    this.documentId = 0;
    this.import = false;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Attestation): Attestation {
    const newAttestation: Attestation = new Attestation();
    newAttestation.id = obj.id;
    newAttestation.etablissementId = obj.etablissementId;
    newAttestation.attestationDefId = obj.attestationDefId;
    newAttestation.dateDemande = obj.dateDemande ? new Date(obj.dateDemande) : null;
    newAttestation.dateStatut = obj.dateStatut ? new Date(obj.dateStatut) : null;
    newAttestation.dateValid = obj.dateValid ? new Date(obj.dateValid) : null;
    newAttestation.statut = obj.statut;
    newAttestation.motif = obj.motif;
    newAttestation.canRenew = obj.canRenew;
    newAttestation.documentId = obj.documentId;
    newAttestation.import = obj.import;
    newAttestation.createId = obj.createId;
    newAttestation.failed = obj.failed;
    newAttestation.canUpdate = obj.canUpdate;
    newAttestation.canDelete = obj.canDelete;
    newAttestation.display = obj.display;
    newAttestation.clientId = obj.clientId;
    newAttestation.notifDefType = obj.notifDefType;
    return newAttestation;
  }

  public toJsonAttestation (): string {
    const json = {
      etablissementId: this.etablissementId,
      attestationDefId: this.attestationDefId,
      dateDemande: this.dateDemande ? new Date (this.dateDemande).toString() : this.dateDemande,
      dateStatut: this.dateStatut ? new Date (this.dateStatut).toString() : this.dateStatut,
      dateValid: this.dateValid ? new Date (this.dateValid).toString() : this.dateValid,
      statut: this.statut,
      motif: this.motif,
      canRenew: this.canRenew,
      documentId: this.documentId,
      import: this.import,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromAttestation (obj: Attestation): void {
    this.id = obj.id;
    this.etablissementId = obj.etablissementId;
    this.attestationDefId = obj.attestationDefId;
    this.dateDemande = obj.dateDemande;
    this.dateStatut = obj.dateStatut;
    this.dateValid = obj.dateValid;
    this.statut = obj.statut;
    this.motif = obj.motif;
    this.canRenew = obj.canRenew;
    this.documentId = obj.documentId;
    this.import = obj.import;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareAttestation (value: Attestation): boolean {
    return (this.toJsonAttestation() == value.toJsonAttestation());
  }

  public cloneAttestation (): Attestation {
    return Attestation.fromJson(this);
  }

  public createForStoreAttestation (): Promise<Attestation> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/attestations/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromAttestation(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreAttestation (): Promise<Attestation> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/attestations/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromAttestation(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreAttestation (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/attestations/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/attestations/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static renew (attestation: Attestation): Promise<Attestation> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/attestations/renew', attestation, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Attestation.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static display (attestation: Attestation): Promise<Attestation> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/attestations/display', attestation, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Attestation.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Attestations/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Attestation.fromJson(listData.reccords[0] as Attestation);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Attestation> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Attestations/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Attestation.fromJson(listData.reccords[0] as Attestation);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(attestations: Attestation[]) {
    attestations.forEach((item) => {
      item.dateDemande = item.dateDemande ? new Date(item.dateDemande) : item.dateDemande;
      item.dateStatut = item.dateStatut ? new Date(item.dateStatut) : item.dateStatut;
      item.dateValid = item.dateValid ? new Date(item.dateValid) : item.dateValid;
    })
  }
}
